import {
  faWindowMaximize,
  faWindowMinimize
} from '@awesome.me/kit-5de77b2c02/icons/classic/regular'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FC, useMemo } from 'react'
import { noop } from 'rxjs'
import { OrderStatus, OrderType } from '../../../store/order/types'
import { SecurityStaticData } from '../../../store/securities/reducer'
import MaturityDate from '../../MaturityDate/MaturityDate'

import styles from '../modal.module.scss'

interface Props {
  type: OrderType
  prefix?: string
  orderStatusComp?: OrderStatus | undefined
  security: SecurityStaticData
  issue?: string
  showMinimize: boolean
  showSecurityInfo: boolean
  isActiveWindow: boolean
  index: number
  handleMinimize: (i: number) => void
}

const HeaderModal: FC<Props> = (props) => {
  const {
    type,
    prefix,
    security,
    issue,
    showMinimize,
    showSecurityInfo,
    handleMinimize,
    index,
    isActiveWindow,
    orderStatusComp
  } = props
  const primaryColor = `var(--${type}PrimaryColor)`
  const secondaryColor = `var(--${type}SecondaryColor)`

  const formattedPrefix = useMemo(() => {
    return prefix ? prefix.trim() + ' ' : ''
  }, [prefix])

  const getModalTitle = () => {
    switch (orderStatusComp) {
      case 'accepted':
        return <span>{type === 'buy' ? 'Bought' : 'Sold'}</span>
      case 'rejected':
        return <span className={styles.completed}>Rejected</span>
      default:
        return (
          <span className={styles.completed}>
            {formattedPrefix}
            {type === 'buy' ? 'Buy' : 'Sell'}
          </span>
        )
    }
  }

  const getMinimizeButton = useMemo(() => {
    if (!showMinimize) return <></>
    return (
      <div
        className={styles.minimize}
        onClick={
          isActiveWindow ? () => handleMinimize && handleMinimize(index) : noop
        }
      >
        <FontAwesomeIcon
          icon={isActiveWindow ? faWindowMinimize : faWindowMaximize}
          style={{ color: primaryColor }}
        />
      </div>
    )
  }, [showMinimize, isActiveWindow])

  return (
    <div
      className={`${styles.rectangleTitle} ${
        isActiveWindow ? styles.active : styles.inactive
      }`}
      onClick={
        !isActiveWindow
          ? () => handleMinimize && handleMinimize(index)
          : undefined
      }
    >
      <div
        className={`${styles.titleBox} ${
          !isActiveWindow ? `${styles.title}` : null
        }`}
        style={{ backgroundColor: secondaryColor }}
      >
        {getModalTitle()}
      </div>
      <div
        className={`${styles.titleCenter} ${
          !isActiveWindow ? `${styles.title}` : null
        }`}
        style={{ backgroundColor: primaryColor }}
      >
        <div className={styles.titleContent}>
          <p className={styles.firstLineContentTitle}>
            {security.issuerSymbol} {security.coupon}{' '}
            <MaturityDate date={security.maturityDate} />
            {showSecurityInfo && (
              <>
                <span className={styles.opacityContent}>
                  {' '}
                  {security.currency}
                </span>
                <span className={styles.issue}>{issue}</span>
              </>
            )}
          </p>
          <div
            className={`${styles.secondLineContentTitle} ${styles.opacityContent}`}
          >
            <span>CUSIP: {security.cusip}</span>
            <span>ISIN: {security.isin}</span>
          </div>
          <p className={styles.opacityContent}>
            Benchmark: {security.benchmarkName}
          </p>
        </div>
      </div>
      {getMinimizeButton}
    </div>
  )
}

export default HeaderModal
